export const USER_TYPES = {
  REGISTERED: 'registered',
  UNREGISTERED: 'unregistered',
};

export const CHAT_STATUS_CLOSED = 3;
